import React from "react";
import { ArrowRight, Lock, FileText } from "lucide-react";
import PremiumBadge from "./PremiumBadge";
import { useI18n } from "../../i18n/I18nContext";

const PrepCard = ({ item, onAction }) => {
  const { t } = useI18n();
  return (
  <div className="flex items-start gap-5 bg-white rounded-xl border border-slate-200 p-6">
    <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-[#0a2540]/5 shrink-0">
      {item.premium ? (
        <Lock className="w-5 h-5 text-[#c9a227]" />
      ) : (
        <FileText className="w-5 h-5 text-[#0a6ed1]" />
      )}
    </span>
    <div className="flex-1">
      <div className="flex items-center gap-2">
        <span className="text-xs font-700 uppercase tracking-wider text-slate-400">{item.kind}</span>
        {item.premium && <PremiumBadge />}
      </div>
      <h3 className="mt-1 font-display font-700 text-lg text-[#0a2540]">{item.title}</h3>
      <p className="mt-1 text-sm text-slate-500 leading-relaxed">{item.desc}</p>
      <button
        onClick={() => onAction(item)}
        className="mt-3 inline-flex items-center gap-1.5 text-sm font-600 text-[#0a2540] hover:text-[#0a6ed1] transition-colors"
      >
        {item.premium ? t("unlock") : t("download")} <ArrowRight className="w-4 h-4 text-[#0a6ed1]" />
      </button>
    </div>
  </div>
  );
};

export default PrepCard;
